__turbopack_context__.v({
  "connectButton": "ConnectButton-module__RMHNCW__connectButton",
});
